import { TAddress, TStates } from '@updater/ui-widgets';
import { ItemStatuses } from '../../../constants';

export interface Address extends TAddress {
  street: string;
  unit?: string | null;
  city: string;
  postalCode: string;
  state: TStates | string;
  status?: string;
  normalizationResponse?: string;
  forced?: boolean;
}

export enum BooleanString {
  TRUE = 'true',
  FALSE = 'false',
}

export interface RESTAddressType {
  street: string;
  apt: string | null;
  city: string;
  zip: string;
  state: string;
  status?: string;
}

export interface ForwardMailFlow {
  addressesNormalized: BooleanString;
  confirmAddresses: string | undefined;
  firstName: string | null;
  lastName: string | null;
  middleName: string | undefined;
  suffixName: string | undefined;
  forwardMailDate: string;
  isMoveTemporary: string;
  stopForwardMailDate?: string;
  whosMoving: string;
  review: string | undefined;
  businessName: string | undefined;
  currentAddress: Address | null;
  newAddress: Address | null;
  isFileEdited: BooleanString;
  isNewForm: BooleanString;
  phone: string | undefined;
  id: string;
  moveId: string;
  status?: ItemStatuses;
  nameId?: string;
  created_at?: string | null;
  form_type?: FormType;
  currentScreen: string | null;
}

export interface UserName {
  first: string;
  last: string;
}

export interface SubmittedFormComponentProps {
  userData: Partial<ForwardMailFlow>;
  onEditFile: (userData: Partial<ForwardMailFlow>) => void;
}
export type FormType = 'individual' | 'family' | 'business';

export interface SubmittedFormProps {
  name: {
    first: string;
    last: string;
    middle?: string;
    suffix?: string;
  };
  form_type: FormType;
  start_date: string;
  end_date: string;
  id: string;
  from_address: RESTAddressType;
  to_address: RESTAddressType;
  move_id: string;
  name_id: string;
  business_name: string;
  status?: ItemStatuses | undefined;
  move?: MoveProps;
}

export interface MoveProps {
  need_verify: boolean;
}

export interface DataProviderProps {
  formData: SubmittedFormProps[];
  loading: boolean;
  error: any;
}
